import { useEffect } from "react";

// Injects a JSON-LD <script> into <head> for the lifetime of the component.
export default function JsonLd({ id, data }) {
  const json = data ? JSON.stringify(data) : null;
  useEffect(() => {
    if (!json) return undefined;
    const el = document.createElement("script");
    el.type = "application/ld+json";
    el.setAttribute("data-jsonld", id);
    el.text = json;
    document.head.appendChild(el);
    return () => el.remove();
  }, [id, json]);
  return null;
}
